module.exports = __webpack_public_path__ + "img/b6c1c90.png";